(function () {
  let timer;
  const lockMs = 1400;
  // 앵커 스무스 스크롤 동안 헤더 collapse 핸들러를 잠금 — 시작/끝의
  // --header-height가 일치해야 도착 위치가 정확. (방향 무관 작동)
  const lockHeader = () => {
    document.documentElement.classList.add('is-anchor-scrolling');
    clearTimeout(timer);
    timer = setTimeout(
      () => document.documentElement.classList.remove('is-anchor-scrolling'),
      lockMs
    );
  };

  const getHash = (href) => {
    try {
      return new URL(href, location.href).hash.slice(1);
    } catch {
      return '';
    }
  };

  const getAnchorTarget = (hash) => {
    if (!hash) return null;
    const id = decodeURIComponent(hash);
    return document.getElementById(id)
      || document.querySelector(`[data-anchor="${CSS.escape(id)}"]`);
  };

  const isSamePageAnchor = (a) => {
    if (!a.hash || a.hash === '#') return false;
    return a.origin === location.origin && a.pathname === location.pathname;
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest?.('a[href]');
    if (!a || !isSamePageAnchor(a)) return;

    const hash = getHash(a.href);
    const target = getAnchorTarget(hash);
    if (!target) return;

    e.preventDefault();
    lockHeader();
    history.pushState(null, '', `#${hash}`);
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  // 네이티브 id 없을 때 data-anchor 폴백
  function scrollToDataAnchor() {
    const hash = location.hash.slice(1);
    const target = getAnchorTarget(hash);
    if (!target) return;
    lockHeader();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  window.addEventListener('DOMContentLoaded', scrollToDataAnchor);
  window.addEventListener('hashchange', scrollToDataAnchor);
})();
